import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PSPDFKit from '../pspdfkit';
import queryString from 'query-string';
import { getDocumentArrayBufferExternal } from '../../api/external';
import AuthService from '../externalauthentication/authservice';
import { isModernApi } from '../..';
import { getCookie, setCookie } from '../termsofuse/utils';
import { TOS_VERSION } from '../termsofuse/termsofusearchive';
import TosModal from '../fillableform/termsofusemodal';
import jwt from 'jsonwebtoken';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

const base64ToArrayBuffer = base64 => {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
};

export function LegacyViewer() {
  const params = useParams();
  const [finishedLoading, setFinishedLoading] = useState(false);
  const [pdfContent, setPdfContent] = useState(null);
  const [isModern, setIsModern] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [districtName, setDistrictName] = useState('');
  const [hidePrintButton, setHidePrintButton] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(
    () => {
      const loadDocument = async () => {
        const documentId = params.superid;

        let pdfContent = null;

        try {
          const auth = new AuthService();
          console.log('legacy created auth');
          const user = await auth.getUser();
          pdfContent = await getDocumentArrayBufferExternal(user, documentId);
          const isModern = isModernApi();
          let showModal = false;
          let districtName = '';
          let hidePrintButton = false;
          if (isModern) {
            const token: any = jwt.decode(user.access_token);
            console.log('token', token);
            districtName = token.s_accountDisplay;
            hidePrintButton =
              token.s_permissions &&
              token.s_permissions.enableInternalPrintButton
                ? true
                : false;
            console.log('*********** got it', districtName);
            const cookie = getCookie(`ARCHIVE_TOS_${TOS_VERSION}`);
            if (!cookie || cookie !== 'accepted') {
              showModal = true;
            }
          }
          setFinishedLoading(true);
          setPdfContent(pdfContent);
          setIsModern(isModern);
          setShowModal(showModal);
          setDistrictName(districtName);
          setHidePrintButton(hidePrintButton);
        } catch (error) {
          console.log('caught error');
          console.log(error);
          setError(true);
          setErrorMessage(error);
        }
      };

      loadDocument();
    },
    [params.superid]
  );

  const acceptTerms = () => {
    setCookie(`ARCHIVE_TOS_${TOS_VERSION}`, 'accepted', 365);
  };

  let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
  console.log(finishedLoading);
  return (
    <div className="App">
      {finishedLoading && (
        <PSPDFKit
          documentId={params.superid}
          pdfUrl={pdfContent}
          licenseKey={licenseKey}
          baseUrl={baseUrl}
          client={'demoso.scribonline.com'}
          hideToolbar={true}
          isExternal={true}
          hidePrint={hidePrintButton}
        />
      )}
      {isModern && (
        <TosModal
          modal={showModal}
          onConfirm={acceptTerms}
          client={'docmanagement.parchment.com'}
          districtName={districtName}
        />
      )}
    </div>
  );
}

export default LegacyViewer;
